import React, { Component } from 'react';

import {Card} from 'material-ui/Card';
import RaisedButton from 'material-ui/RaisedButton';
import TextField from 'material-ui/TextField';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import Dialog from 'material-ui/Dialog';

import AddressField from '../elements/AddressField';

import Config from '../../conf';
import {CarDetails as styles} from './form.css';

const equiemCarparks = [
  "135 King St Sydney 2000",
  "1 Market St Sydney 2000",
  "126 Phillip Sydney 2000",
  "201 Kent St Sydney 2000",
  "420 George St Sydney 2000",
  "133 Castlereagh St",
  "222 Pitt St Sydney 2000",
  "5 Martin place Sydney 2000",
  "1 Bligh St Sydney 2000",
  "MLC Centre Sydney 2000",
  "1 Farrer Sydney 2000",
  "60 Castlereagh Sydney 2000"
];

class DateTime extends Component {

  constructor(props) {
    super(props);

    this.state = {
      postcode: null,

      // Tempoary address
      dropdownLocation: '',
      addressConfirmation: false,
      addressConfirmed: false
    };

    this.fieldChanged = this.fieldChanged.bind(this);
    this.nextDisabled = this.nextDisabled.bind(this);
    this.closeDialog = this.closeDialog.bind(this);

    this.updateAddress = this.updateAddress.bind(this);
  }

  nextDisabled() {
    let ret = !this.props.details.address ||
              !this.props.details.numberPlate ||
              !this.props.details.carType;
    return ret;
  }

  fieldChanged(fieldName, newValue) {
    this.props.setHasError(fieldName, false);
    this.props.updateField(fieldName, newValue);
  }

  closeDialog() {
    this.setState({
      addressConfirmation: false
    });
  }

  updateAddress(evt, field, val) {
    this.setState({
      dropdownLocation: val,
      addressConfirmation: true
    }, () => {
      this.fieldChanged('address', val);
    });
  }

  render() {
    const actions = [
      <RaisedButton
        label="OK"
        primary={false}
        onTouchTap={() => this.closeDialog(false)}
        style={styles.dialogButton}
      />
    ];

    return (
      <div>
        <Dialog
          title="Please Confirm Address"
          actions={actions}
          modal={false}
          open={this.state.addressConfirmation}
          onRequestClose={this.closeDialog}
          bodyStyle={styles.center}
          titleStyle={styles.center}
          className="counteract-zoom"
        >
          <AddressField
            styles={styles}
            details={this.props.details}
            fieldChanged={this.fieldChanged}
            isOpen={true}
          />
          
        </Dialog>

        <Card style={styles.card}>
          <h2 style={styles.title}>Welcome</h2>
          
          <div style={styles.paragraph}>
            Welcome to the mobile carwash service for {Config.CLIENT_NAME}.
          </div>
          <br/>
          
          <div style={styles.dateTimeWrapper}>

            <h3>{Config.CLIENT_NAME === "Workspace" ? "Select Carpark": "Enter Address"}</h3>
            {Config.CLIENT_NAME === "Workspace" &&
              <div>
                <SelectField
                  style={styles.textField}
                  floatingLabelText=""
                  value={this.state.dropdownLocation}
                  onChange={this.updateAddress}
                >
                  {equiemCarparks.map((location, idx) => {
                    return (
                      <MenuItem key={idx} value={location} primaryText={location} />
                    );
                  })
                  }
                </SelectField>

                <TextField
                  style={styles.textField}
                  hintStyle={styles.hintStyle}
                  inputStyle={styles.inputStyle}
                  hintText="Carpark Level"
                  floatingLabelText={this.props.details.carParkLevel ? 'Carpark Level' : ' '}
                  floatingLabelFixed={true}
                  maxLength={2}
                  onChange={(evt) => this.fieldChanged('carParkLevel', evt.target.value)}
                  value={this.props.details.carParkLevel}
                />

                <TextField
                  style={styles.textField}
                  hintStyle={styles.hintStyle}
                  inputStyle={styles.inputStyle}
                  hintText="Carpark Spot Number or Description"
                  floatingLabelText={this.props.details.carParkSpot ? 'Carpark Spot Number or Description' : ' '}
                  floatingLabelFixed={true}
                  maxLength={100}
                  onChange={(evt) => this.fieldChanged('carParkSpot', evt.target.value)}
                  value={this.props.details.carParkSpot}
                />
              </div>
            }

            {Config.CLIENT_NAME !== "Workspace" &&
              <AddressField
                styles={styles}
                details={this.props.details}
                fieldChanged={this.fieldChanged}
                disabled={this.state.addressConfirmed}
              />
            }

            <h3>Car Details</h3>

            <TextField
              style={styles.textField}
              hintStyle={styles.hintStyle}
              inputStyle={styles.inputStyle}
              hintText="Number Plate"
              floatingLabelText={this.props.details.numberPlate ? 'Number Plate' : ' '}
              floatingLabelFixed={true}
              maxLength={8}
              onChange={(evt) => this.fieldChanged('numberPlate', evt.target.value.toUpperCase())}
              value={this.props.details.numberPlate}
            />

            <p style={{paddingTop: 5}}>What type of car do you have?</p>
            <SelectField
              style={styles.textField}
              floatingLabelText=""
              value={this.props.details.carType}
              onChange={this.props.setCarType}
            >
              <MenuItem value={'Sedan'} primaryText="Sedan" />
              <MenuItem value={'SUV'} primaryText="SUV" />
              <MenuItem value={'Van'} primaryText="Van" />
            </SelectField>
          </div>

          <RaisedButton style={styles.button} disabled={this.nextDisabled()}
            label="Next" primary={true} onClick={this.props.next} />
        </Card>
        
      </div>
    );
  }
}

export default DateTime;



// WEBPACK FOOTER //
// ./src/app/components/form/CarDetails.js